import React, { useContext } from 'react'
import Heading from '@react/react-spectrum/Heading'
import CompareImage from '../Nav/CompareImage'
import IconImage from '@react/react-spectrum/Icon/Image'
import { Image } from '@react/react-spectrum/Image'
import { EasybakeContext } from '../EasybakeProvider'
import Link from '../Nav/Link'
import Spinner from '../Nav/Spinner'
import ImageWait from '../Nav/ImageWait'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import CodeSnippet from '../Nav/CodeSnippet'
import code from '../../asset/code/autotone.txt'
import CacheMultilineText from '../Nav/CacheMultilineText'
import MultilineText from '../Nav/MultilineText'
import useImageEffect from '../hooks/useImageEffect'

export default function Autotone () {
    const { spinnerTimeout, wait, group } = useContext(EasybakeContext)
    const { beforeImage, afterImage } = useImageEffect({ group: 'autotone' })
    const caption = `${__('autotone_applying')}\u2026`
    const descriptionKey = 'autotone_desc'

    return (
        <div className="adobe-easybake-main-pane">
            <div className="adobe-easybake-main adobe-easybake-autotone">
                <CacheMultilineText localizationKey={descriptionKey}/>
                <div className="adobe-easybake-file-info">
                    <div className="adobe-easybake-icon-image-container">
                        <IconImage className="adobe-easybake-icon-image" size="S" />
                    </div>
                    <div className="adobe-easybake-file-name">{__('autotone_image_title')}</div>
                </div>
                <div className="adobe-easybake-image-preview">
                    {group && wait &&
                        <React.Fragment>
                            <Image className="adobe-easybake-original-img" src={beforeImage} alt="original img"/>
                            <Spinner timeout={spinnerTimeout} caption={caption} className="spinner"/>
                        </React.Fragment>
                    }
                    {group && !wait &&
                        <CompareImage spinnerCaption={caption} before={beforeImage} after={afterImage} />
                    }
                    {!group &&
                        <ImageWait caption={`${__('loading_image')}\u2026`} className="adobe-easybake-original-img" src={beforeImage} alt="original img"/>
                    }
                </div>
                {group === 'autotone' && !wait &&
                    <div className="adobe-easybake-api-detail">
                        <div className="adobe-easybake-code-preview">
                            <CodeSnippet language="json" url={code}/>
                        </div>
                        <div className="adobe-easybake-desc">
                            <Heading className="adobe-easybake-desc-heading" variant="subtitle2">{__('autotone_title')}</Heading>
                            <MultilineText localizationKey={descriptionKey}/>
                            <Link className="adobe-easybake-desc-link" referrer={`documentation:${group}:main`} label={__('link_doc')} url={__('url_doc_autotone')} />
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}
